import axios from 'axios'
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster'

import { cleanEntity } from '../../../utils/entity-utils'
import { FAILURE, REQUEST, SUCCESS } from '../../../shared/reducers/action-type.util'

import { defaultValue, ITournamentMatch } from '../../../shared/model/tournament-match.model'

export const ACTION_TYPES = {
  FETCH_UPCOMINGDMATCH_LIST: 'tournamentMatch/FETCH_UPCOMINGDMATCH_LIST',
  FETCH_UPCOMINGDMATCH: 'tournamentMatch/FETCH_UPCOMINGDMATCH',
  UPDATE_UPCOMINGDMATCH: 'tournamentMatch/UPDATE_UPCOMINGDMATCH',
  RESET: 'tournamentMatch/RESET',
}

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<ITournamentMatch>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
}

export type MatchesUpcomingState = Readonly<typeof initialState>;

// Reducer
export default (state: MatchesUpcomingState = initialState, action): MatchesUpcomingState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_UPCOMINGDMATCH_LIST):
    case REQUEST(ACTION_TYPES.FETCH_UPCOMINGDMATCH):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      }
    case REQUEST(ACTION_TYPES.UPDATE_UPCOMINGDMATCH):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      }
    case FAILURE(ACTION_TYPES.FETCH_UPCOMINGDMATCH_LIST):
    case FAILURE(ACTION_TYPES.FETCH_UPCOMINGDMATCH):
    case FAILURE(ACTION_TYPES.UPDATE_UPCOMINGDMATCH):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      }
    case SUCCESS(ACTION_TYPES.FETCH_UPCOMINGDMATCH_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      }
    case SUCCESS(ACTION_TYPES.FETCH_UPCOMINGDMATCH):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      }
    case SUCCESS(ACTION_TYPES.UPDATE_UPCOMINGDMATCH):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      }
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      }
    default:
      return state
  }
};

const apiUrl = '/api/management/upcoming-matches'

// Actions
export const getEntities: ICrudGetAllAction<ITournamentMatch> = (page, size, sort, round?: number, session?: string, eventId?: number) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}
  ${round ? sort ? `&round=${round}` : `?round=${round}` : ''}
  ${eventId ? sort ? `&eventId=${eventId}` : `?eventId=${eventId}` : ''}
  ${session ? sort || round ? `&session=${session}` : `?session=${session}` : ''}`
  return {
    type: ACTION_TYPES.FETCH_UPCOMINGDMATCH_LIST,
    payload: axios.get<ITournamentMatch>(`${requestUrl}${requestUrl.indexOf('?') >= 0 ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  }
}

export const getEntity: ICrudGetAction<ITournamentMatch> = id => {
  const requestUrl = `${apiUrl}/${id}`
  return {
    type: ACTION_TYPES.FETCH_UPCOMINGDMATCH,
    payload: axios.get<ITournamentMatch>(requestUrl),
  }
}

export const updateEntity: ICrudPutAction<ITournamentMatch> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_UPCOMINGDMATCH,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  })
  dispatch(getEntities())
  return result
}

export const reset = () => ({
  type: ACTION_TYPES.RESET,
})
